<template>
	<div>
		<el-dialog
		  :visible="visible"
		  :width="requiredDialogWidth"
		  @close='handleCancleYoutubePlay'
		  center>
			  <div slot="title" style="background-color: #222a33 !important;border-top-left-radius:15px;border-top-right-radius:15px">
					<p class="white fs32 fw500" style="height: 2.5rem;line-height: 2.5rem;">{{ $t('kindlyReminder') }}</p>
			  </div>
			  <div class="center gray fs18">
				  <div class="center">
						<div style="color: red;">
							<p class="wordbreakno" v-for="v in p" :class="$style.reqP">{{ v }}</p>
						</div>
						<el-button  type="warning" size="small"  round @click="closeDialog">{{$t('close')}}</el-button>
				  </div>
			  </div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "ReminderDialog",
	props: {
		p : {type: Array,default:() => ([])},
		requiredDialogVisible: {type: Boolean,default: ()=>(false)},
		close: {
			type: Function,
			default: () => {},
		},
	},
	data(){
		return {
			requiredDialogWidth:document.body.clientWidth < 770 ? '90%' : '50%',
			visible: this.requiredDialogVisible,
		}
	},
	watch:{
		requiredDialogVisible(){
			this.visible = this.requiredDialogVisible;
		}
	},
	methods: {
		handleCancleYoutubePlay(){
			this.closeDialog();
		},
		closeDialog() {
			this.visible = false;
			this.close();
		}
	},
}	
</script>
<style scoped >
/deep/	.el-dialog__headerbtn {
	top: 15px;
}
/deep/	.el-dialog__headerbtn i {
	font-size: 3.125rem;
	color: white;
}
</style>
<style module>
	.reqP {
		margin-bottom: 0.625rem;
	}
</style>